import React from "react";
import "./Footer.css";

function Footer() {
    return (
        <>
            <footer className="footer">
                <p className="footer-link">
                    <br></br>
                    <a
                        href="https://github.com/belowrd"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        contact
                    </a>
                </p>
            </footer>
        </>
    );
}

export default Footer;
